import { apiClient } from "./client";

export const visitsApi = {
  list: async (params = {}) => (await apiClient.get("/scheduling/visits/", { params })).data,

  get: async (id) => (await apiClient.get(`/scheduling/visits/${id}/`)).data,

  create: async (data) => (await apiClient.post("/scheduling/visits/", data)).data,

  update: async (id, data) => (await apiClient.patch(`/scheduling/visits/${id}/`, data)).data,

  delete: async (id) => {
    await apiClient.delete(`/scheduling/visits/${id}/`);
  },

  // Documentation API methods
  checkIn: async (id) => (await apiClient.post(`/scheduling/visits/${id}/check_in/`)).data,

  checkOut: async (id, clinicalNotes) =>
    (await apiClient.post(`/scheduling/visits/${id}/check_out/`, { clinical_notes: clinicalNotes })).data,

  saveNotes: async (id, clinicalNotes) =>
    (await apiClient.post(`/scheduling/visits/${id}/save_notes/`, { clinical_notes: clinicalNotes })).data,

  updateVitals: async (id, vitalsData) =>
    (await apiClient.post(`/scheduling/visits/${id}/vitals/`, vitalsData)).data,

  addTask: async (id, title) =>
    (await apiClient.post(`/scheduling/visits/${id}/add_task/`, { title })).data,

  toggleTask: async (visitId, taskId, isCompleted) =>
    (await apiClient.patch(`/scheduling/visits/${visitId}/tasks/${taskId}/`, { is_completed: isCompleted })).data,
};
